/**
 * 取得 LocalStorage
 * @param key
 * @returns {any|string|undefined}
 */
export function getLocalStorage(key) {
  const localStorageItem = window.localStorage.getItem(key);

  if(!localStorageItem) {
    return undefined;
  }

  /* if(localStorageItem === 'true') {
    return true;
  }

  if(localStorageItem === 'false') {
    return false;
  }

  if(localStorageItem === 'null') {
    return null;
  } */

  if(localStorageItem === 'undefined') {
    return undefined;
  }

  /* return typeof localStorageItem === 'object'
   ? JSON.parse(localStorageItem)
   : localStorageItem */
  return typeof localStorageItem === 'string'
    ? JSON.parse(localStorageItem)
    : localStorageItem
}

export function setLocalStorage(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}
